var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-print"},[_c('div',{attrs:{"id":"printMe"}}),_c('v-btn',{staticClass:"btn-cat",attrs:{"color":"#143d9d","text":"","outlined":""},on:{"click":_vm.printing}},[_vm._v("Напечатать ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }